/* eslint-disable no-throw-literal */
import { Dispatch } from "redux"
import { camelize } from "../../config/functions"
import { addSales, deleteSales, editSales, getSales, getSalesByDate, getSalesById, getSalesByInvoiceDate } from "../../services/sales.service "


export enum SalesPaymentModesDropDown {
    CASH = "Cash",
    BANK = "Bank",
    CREDIT = "Credit",
}
export type SalesPaymentModeTypes = SalesPaymentModesDropDown.CASH | SalesPaymentModesDropDown.BANK | SalesPaymentModesDropDown.CREDIT

export enum SalesModeDropDown {
    ONLINE = "online",
    OFFLINE = "offline",
}
export type SalesModeTypes = SalesModeDropDown.ONLINE | SalesModeDropDown.OFFLINE

export enum SalesActionList {
    ADD_SALES = 'ADD_SALES',
    FETCH_SALES = 'FETCH_SALES',
    UPDATE_SALES = 'UPDATE_SALES',
    DELETE_SALES = 'DELETE_SALES',
}

export interface SalesItems {
    id?: number
    salesId?: number
    entryNumber: number
    productId: number
    productCode: string
    batchNumber: number
    expiryDate: string
    quantity: string
    freeQuantity: string
    totalQuantity: string
    priceWogst: number
    priceGst: number
    wRate: number
    // rRate: number
    // lRate: number
    mrp: number
    gstValue: number
    sDiscount: number
    pDiscountpercent: number
    pDiscountamount: number
    cDiscountpercent: number
    cDiscountamount: number
    taxableAmount: number
    igstAmount: number
    cgstAmount: number
    sgstAmount: number
    totalAmount: number
    unitCost: number
    profitPercent: number
    profitAmount: number
}

export interface SalesType {
    // id?: number
    // invoiceDate: string
    // invoiceNo: string
    // SalesEntryNo: string
    // supplierId: number
    // finalAmount: string
    id?: number
    financeYear: string
    branchId: number
    invoiceType: string
    invoiceTitle: string
    invoiceDate: string
    // goodsReceivedDate: string
    invoiceDay?: string
    invoiceWeekNumber?: number
    invoiceWeekDay?: number
    invoiceMonth?: number
    invoiceYear?: number
    invoiceNumber: string
    packNo: string
    salesEntryNumber: number
    systemNo: string
    placeOfSupply?: string
    repId?: number
    customerId: number
    customerName: string
    salesItems: SalesItems[]
    /////new
    pointsEarned?: string
    bankName: string
    bankNumber: number
    paymentMode: SalesPaymentModeTypes
    salesMode?: SalesModeTypes
    // paymentMode: string
    billAmount?: string
    disPercent?: string
    disAmount?: string
    totalAmount?: string
    totalDiscount?: string
    roundOff?: string
    prevBal?: string
    totalBal?: string
    cash?: string
    card1?: string
    card2?: string
    onlinePayment1?: string
    onlinePayment2?: string
    credit?: string
    ledgerBal?: string
    bankReceived?: string
    add?: string
    less?: string
    grandTotal?: string
    amtInWords?: string
    particulars?: string
    amtPaid?: string
    deliveryMode?: string
    deliveryDetails?: string
    remarks?: string
    tenderAmt?: string
    tenderReturn?: string
    netTaxable?: string
    netIgst?: string
    netSgst?: string
    netCgst?: string
    netProfit?: string
    netProfitPercent?: string
    AValue?: string
    ATaxable?: string
    BValue?: string
    BTaxable?: string
    CValue?: string
    CTaxable?: string
    DValue?: string
    DTaxable?: string
    EValue?: string
    ETaxable?: string
    FValue?: string
    FTaxable?: string
    GValue?: string
    GTaxable?: string
    isPointsRedeemed?: boolean
    split?: string
    transactions: ({
        paymentMode: string;
        particulars: string;
        amtPaid: number;
    })[]
}

export interface AddSalesAction {
    type: SalesActionList.ADD_SALES
    data: SalesType
}

export interface FetchSalesAction {
    type: SalesActionList.FETCH_SALES
    data: Array<SalesType>
}

export interface UpdateSalesAction {
    type: SalesActionList.UPDATE_SALES
    data: SalesType
    id: number
}

export interface DeleteSalesAction {
    type: SalesActionList.DELETE_SALES
    data: number
}

export type SalesActions = AddSalesAction | FetchSalesAction | UpdateSalesAction | DeleteSalesAction

/** Normalize API rows (snake_case) into SalesType (camelCase). */
function mapApiRowsToSalesType(rows: unknown[]): SalesType[] {
    return rows.map((res) => {
        const row = (res ?? {}) as Record<string, unknown>
        const camelCase: Record<string, unknown> = {}
        for (const key of Object.keys(row)) {
            camelCase[camelize(key)] = row[key]
        }
        return camelCase as unknown as SalesType
    })
}

export const addSalesAction = (data: SalesType) => {
    // return async (dispatch: Dispatch, getState: GetState) => {

    return async (dispatch: Dispatch) => {
        return addSales(data).then(response => {
            if (response.status === 200 && response.data.data) {
                let addData = {}
                for (let i = 0; i < Object.keys(response.data.data).length; i++) {
                    const key = camelize(Object.keys(response.data.data)[i])
                    const value = Object.values(response.data.data)[i]
                    addData = { ...addData, [key]: value }
                }
                dispatch<AddSalesAction>({
                    type: SalesActionList.ADD_SALES,
                    data: data
                })
                return Promise.resolve({
                    message: response.data.message
                        ? response.data.message
                        : 'Sales Added',
                    data: addData as {
                        id?: number;
                        invoiceNumber?: string;
                        salesEntryNumber?: string | number;
                        nextInvoiceNumber?: string;
                    },
                })
            } else {
                throw { response }
            }
        }).catch(error => {
            return Promise.reject(error.response
                ? error.response.data.message
                    ? error.response.data.message
                    : 'Unable to add'
                : 'Unable to add')
        })

    }
    // dispatch<AddSalesAction>({
    //     type: SalesActionList.ADD_SALES,
    //     data: {
    //         ...data,
    //         id: parseInt(nanoid(5))
    //     }
    // })

    // const token = getState().authUser.token!
    // const config = getAxiosRequestConfig(token)

    // // return Promise.resolve("Sales Added")
    // return api().post<APIResponse<SalesType>>('Sales/', data, config).then(response => {
    //     if (response.status === 200 && response.data.data) {

    //         dispatch<AddSalesAction>({
    //             type: SalesActionList.ADD_SALES,
    //             data: response.data.data
    //         })
    //         return Promise.resolve(response.data.message
    //             ? response.data.message
    //             : 'Sales Added')
    //     } else {
    //         throw { response }
    //     }
    // }).catch(error => {
    //     return Promise.reject(error.response
    //         ? error.response.data.message
    //             ? error.response.data.message
    //             : 'Unable to add'
    //         : 'Unable to add')
    // })
    // }
}

export const updateSalesAction = (data: SalesType, id: number) => {
    // return async (dispatch: Dispatch, getState: GetState) => {

    return async (dispatch: Dispatch) => {
        return editSales(data, id).then(response => {
            if (response.status === 200 && response.data.data) {
                let editData = {}
                for (let i = 0; i < Object.keys(response.data.data).length; i++) {
                    const key = camelize(Object.keys(response.data.data)[i])
                    const value = Object.values(response.data.data)[i]
                    editData = { ...editData, [key]: value }
                }
                dispatch<UpdateSalesAction>({
                    type: SalesActionList.UPDATE_SALES,
                    data: data,
                    id: id
                })
                return Promise.resolve(response.data.message
                    ? response.data.message
                    : 'Sales Updated')
            } else {
                throw { response }
            }
        }).catch(error => {
            return Promise.reject(error.response
                ? error.response.data.message
                    ? error.response.data.message
                    : 'Unable to update'
                : 'Unable to update')
        })

    }

    // const token = getState().authUser.token!
    // const config = getAxiosRequestConfig(token)

    // // return Promise.resolve("Sales Updated")
    // return api().put<APIResponse<SalesType>>(`Sales/?id=${id}`, data, config).then(response => {
    //     if (response.status === 200 && response.data.data) {
    //         dispatch<UpdateSalesAction>({
    //             type: SalesActionList.UPDATE_SALES,
    //             data: response.data.data
    //         })
    //         return Promise.resolve(response.data.message
    //             ? response.data.message
    //             : 'Sales Updated')
    //     } else {
    //         throw { response }
    //     }
    // }).catch(error => {
    //     return Promise.reject(error.response
    //         ? error.response.data.message
    //             ? error.response.data.message
    //             : 'Unable to update'
    //         : 'Unable to update')
    // })
}

export const fetchSalesByIdAction = (id: number) => {
    return async (dispatch: Dispatch) => {
        const response = await getSalesById(id)
        const data = response.data.data.map((res: any) => {
            let camelCase = {}
            for (let i = 0; i < Object.keys(res).length; i++) {
                const key = camelize(Object.keys(res)[i])
                const value = Object.values(res)[i]
                camelCase = { ...camelCase, [key]: value }
            }
            return camelCase
        })
        return data
        // dispatch<FetchSalesAction>({
        //     type: SalesActionList.FETCH_SALES,
        //     data: data
        // })
    }
}

export const fetchSalesAction = () => {
    return async (dispatch: Dispatch) => {
        const response = await getSales()
        const data = response.data.data.map((res: any) => {
            let camelCase = {}
            for (let i = 0; i < Object.keys(res).length; i++) {
                const key = camelize(Object.keys(res)[i])
                const value = Object.values(res)[i]
                camelCase = { ...camelCase, [key]: value }
            }
            return camelCase
        })
        dispatch<FetchSalesAction>({
            type: SalesActionList.FETCH_SALES,
            data: data
        })
    }
    // return async (dispatch: Dispatch, getState: GetState) => {

    // dispatch<FetchSalesAction>({
    //     type: SalesActionList.FETCH_SALES,
    //     data: SalesSampleData
    // })
    // const token = getState().authUser.token!
    // const config = getAxiosRequestConfig(token)

    // return api().get<APIResponse<SalesType[]>>('Sales/', config).then(response => {
    //     if (response.status === 200 && response.data.data) {
    //         dispatch<FetchSalesAction>({
    //             type: SalesActionList.FETCH_SALES,
    //             data: response.data.data
    //         })
    //         return Promise.resolve(response.data.message
    //             ? response.data.message
    //             : 'Fetch Successfull')
    //     } else {
    //         throw { response }
    //     }
    // }).catch(error => {
    //     return Promise.reject(error.response
    //         ? error.response.data.message
    //             ? error.response.data.message
    //             : 'Unable to fetch'
    //         : 'Unable to fetch')
    // })
    // }
}

export const deleteSalesAction = (id: number) => {
    return async (dispatch: Dispatch) => {
        return deleteSales(id).then(response => {
            if (response.status === 200) {
                dispatch<DeleteSalesAction>({
                    type: SalesActionList.DELETE_SALES,
                    data: id
                })
                return Promise.resolve(response.data.message
                    ? response.data.message
                    : 'Sales Deleted')
            } else {
                throw { response }
            }
        }).catch(error => {
            return Promise.reject(error.response
                ? error.response.data.message
                    ? error.response.data.message
                    : 'Unable to delete'
                : 'Unable to delete')
        })
    }
    // return async (dispatch: Dispatch, getState: GetState) => {

    // dispatch<DeleteSalesAction>({
    //     type: SalesActionList.DELETE_SALES,
    //     data: id
    // })

    // const token = getState().authUser.token!
    // const config = getAxiosRequestConfig(token)

    // // return Promise.resolve("Sales Deleted")
    // return api().delete<APIResponse<SalesType>>(`Sales/?id=${id}`, config).then(response => {
    //     if (response.status === 200) {
    //         dispatch<DeleteSalesAction>({
    //             type: SalesActionList.DELETE_SALES,
    //             data: id
    //         })
    //         return Promise.resolve(response.data.message
    //             ? response.data.message
    //             : 'Sales Deleted')
    //     } else {
    //         throw { response }
    //     }
    // }).catch(error => {
    //     return Promise.reject(error.response
    //         ? error.response.data.message
    //             ? error.response.data.message
    //             : 'Unable to delete'
    //         : 'Unable to delete')
    // })
    // }
}



export const fetchSalesByDateAction = (startDate: string, endDate: string) => {
    return async (dispatch: Dispatch) => {
        const response = await getSalesByDate(startDate, endDate)
        console.log(response);
        const data = response.data.data.map((res: any) => {
            let camelCase = {}
            for (let i = 0; i < Object.keys(res).length; i++) {
                const key = camelize(Object.keys(res)[i])
                const value = Object.values(res)[i]
                camelCase = { ...camelCase, [key]: value }
            }
            return camelCase
        })
        dispatch<FetchSalesAction>({
            type: SalesActionList.FETCH_SALES,
            data: data
        })
    }
}

export const fetchSalesByInvocieDateAction = (invoiceDate: string) => {
    return async (dispatch: Dispatch) => {
        try {
            const response = await getSalesByInvoiceDate(invoiceDate)
            const raw = response?.data?.data
            const list = Array.isArray(raw) ? raw : []
            const data = mapApiRowsToSalesType(list)
            dispatch<FetchSalesAction>({
                type: SalesActionList.FETCH_SALES,
                data,
            })
        } catch {
            dispatch<FetchSalesAction>({
                type: SalesActionList.FETCH_SALES,
                data: [],
            })
        }
    }
}
